import { z } from 'zod';

export default z.object({
  // the URL of the file to download
  url: z.string(),
  // the filename to save the file as. If not provided, the filename will be
  // extracted from the URL or the server response headers
  filename: z.string().optional().nullable(),
  // the expected file extension of the file
  extension: z.string(),
  // additional headers to send with the request
  headers: z.record(z.string()).optional(),
});
